import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastWarnComponent } from "./tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "./tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "./tools/template/toast/toast-success/toast-success.component"; // ✅ ต้อง import
import { ToastCustomService } from './tools/services/toast/toast-custom/toastCustom.service';
import { CommonModule } from '@angular/common';
import { LanguageService } from './core/services/language.service';
import { PssLoadBeginComponent } from "./tools/template/pss/pss-load-begin/pss-load-begin.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastWarnComponent, ToastFailedComponent, ToastSuccessComponent, CommonModule, PssLoadBeginComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'cityparking-liff';
  appVersion = '0.0.0';
  isLoadingBegin: boolean = false
  countStartWeb: number = 0

  constructor(
    private http: HttpClient,
    public toastCustomService: ToastCustomService,
    private languageService: LanguageService,
    private router: Router
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      toastCustomService.currentLang = lang;
    });
  } // ✅ Inject HttpClient
  ngOnInit() {
    this.checkAppVersion();
    this.preventInputFocusZoom();

    // สำหรับโชว์ Begin Logo
    this.countStartWeb = 0
    if (this.countStartWeb == 0) {
      // console.log('โหลดหน้าแรก ครั้งแรก', this.countStartWeb);
      this.countStartWeb = 1
      this.isLoadingBegin = true

      //localStorage.setItem('countStartWeb','0')
    }
  }

  /** กันซูมตอนโฟกัส input บนมือถือ / LINE WebView */
  private preventInputFocusZoom(): void {
    const viewportContent =
      'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover, interactive-widget=resizes-content';

    const lockViewport = () => {
      let meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'viewport';
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', viewportContent);
    };

    const isFormField = (el: EventTarget | null): el is HTMLElement => {
      if (!(el instanceof HTMLElement)) return false;
      const tag = el.tagName;
      if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
      if (tag !== 'INPUT') return false;
      const type = ((el as HTMLInputElement).type || 'text').toLowerCase();
      return !['checkbox', 'radio', 'range', 'file', 'button', 'submit', 'reset', 'image', 'hidden'].includes(type);
    };

    const forceReadableFont = (el: HTMLElement) => {
      el.style.setProperty('font-size', '16px', 'important');
    };

    lockViewport();

    // ใส่ขนาดตัวอักษรตั้งแต่แรก (ก่อนโฟกัส) — iOS เช็คตอนโฟกัส
    document.querySelectorAll('input, textarea, select').forEach((node) => {
      if (isFormField(node)) forceReadableFont(node);
    });

    document.addEventListener(
      'focusin',
      (e) => {
        lockViewport();
        if (isFormField(e.target)) {
          forceReadableFont(e.target);
        }
      },
      true,
    );

    document.addEventListener(
      'touchstart',
      (e) => {
        if (isFormField(e.target)) {
          lockViewport();
          forceReadableFont(e.target);
        }
      },
      { capture: true, passive: true },
    );

    document.addEventListener('gesturestart', (e) => e.preventDefault(), { passive: false });
    document.addEventListener('gesturechange', (e) => e.preventDefault(), { passive: false });
    document.addEventListener('gestureend', (e) => e.preventDefault(), { passive: false });
  }

  checkAppVersion(): void {
    this.http
      .get<{ version: string }>('/version.json', {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe((response) => {
        const currentVersion = localStorage.getItem('app_version');

        if (currentVersion && currentVersion !== response.version) {
          this.appVersion = response.version;
          console.log('🔄 เวอร์ชันใหม่พบ → โหลดหน้าใหม่');
          localStorage.setItem('app_version', response.version);
          location.reload();
        } else {
          localStorage.setItem('app_version', response.version);
        }
      });
  }
}
